{
  "title": "如何在活動現場驗票與核對乘客名單",
  "description": "工作人員使用接駁車驗票頁掃描乘車 QR（含離線暫存），並以乘客名單人工核對。",
  "headings": [
    "你會完成什麼",
    "適用角色",
    "操作前確認",
    "操作步驟",
    "完成後",
    "常見問題"
  ],
  "summary": "完成後，每位乘客的上車都有一筆驗票紀錄，重複掃描與錯誤班次也會留下紀錄；網路不穩時可離線暫存再同步。",
  "roleNote": "活動工作人員：Scanner 與 Owner 可驗票與看乘客名單（需 checkin、manifest 能力）；Manager 與 Viewer 不可驗票",
  "prerequisites": [
    "已被加入該活動的成員，且帳號 Email 已驗證（先被加入但尚未註冊者顯示為「待註冊」，註冊並驗證後生效）",
    "裝置能使用相機（BarcodeDetector）更方便；不支援時可改貼上憑證",
    "事先確認各班次代碼，例如 113 是第一天臺北大學站往會場"
  ],
  "pathLabel": "活動頁 → 工作人員與參與者 → 接駁車驗票（/events/:slug/staff/check-in）、乘客名單（/events/:slug/staff/roster）",
  "steps": [
    {
      "title": "1. 選擇目前班次",
      "description": "進入「接駁車驗票」，在「目前班次」選單選擇要驗的班次。選單顯示「代碼 · 出發時間 · 起訖站」，避免只看到數字。每筆預約只能在正確的班次成功驗一次。"
    },
    {
      "title": "2. 掃描乘車 QR",
      "description": "按「開啟相機掃描」對準乘客的 QR，或在「乘車憑證」貼上憑證後按「驗票」。結果面板以圖示、文字與顏色顯示：驗票成功、重複掃描（已驗過）、班次不符、無效憑證、此預約未確認（候補或已取消）。頁面會累計「本次已驗票」，只計伺服器確認的成功。驗票結果只顯示乘客名稱，不會顯示 Email 或其他個資。"
    },
    {
      "title": "3. 例外要人工處理",
      "description": "重複、班次不符或無效時，面板會標示「需要人工處理」。請請乘客出示證件並到「乘客名單」核對姓名；同行者以自己的姓名出現在名單。這些非成功結果也會留存為稽核紀錄。"
    },
    {
      "title": "4. 網路中斷時離線暫存",
      "description": "沒有網路時，掃描會暫存在這台裝置並標示「已離線暫存（待同步，結果以伺服器為準）」，這不等於驗票成功。恢復連線後按「立即同步」，系統一次最多同步 200 筆，並顯示已同步筆數與其中非成功筆數。多台裝置掃同一張 QR 時伺服器仍只承認一次成功。"
    },
    {
      "title": "5. 用乘客名單核對",
      "description": "進入「乘客名單」，選擇接駁時段，可用「搜尋姓名或單位」與狀態篩選（全部、未驗票、已驗票、候補），頁面顯示「已驗票 X / Y 人」與目前顯示人數。名單顯示姓名、單位、職稱與狀態，不含行動電話。只有 Owner 可按「顯示緊急聯絡電話」載入電話，每次載入都會寫入稽核紀錄，請只在緊急聯絡時使用。"
    }
  ],
  "afterward": [
    "主辦方後台的總覽 KPI 會反映已驗票數",
    "離線暫存的項目在同步前不要清除瀏覽器資料"
  ],
  "nextSteps": "成員權限與後台設定請見「如何管理活動成員與主辦方後台」。",
  "warning": "離線暫存只是暫定記錄。請在恢復網路後立刻同步，並以伺服器結果為準。",
  "faq": [
    {
      "q": "掃描出「班次不符」怎麼辦？",
      "a": "確認驗票頁選到的班次是否與乘客票面班次相同。確實坐錯班時由現場人員人工處理，系統不會把它算成功。"
    },
    {
      "q": "候補的乘客可以上車嗎？",
      "a": "候補沒有 QR，也不是已確認座位。有人取消後會自動遞補並通知，遞補成功後才會有可驗票的 QR。"
    },
    {
      "q": "我看不到驗票頁或名單？",
      "a": "你的活動角色沒有對應能力。Scanner 與 Owner 才有驗票與名單，請向活動 Owner 確認。"
    }
  ],
  "figures": [
    {
      "name": "check-in",
      "alt": "接駁車驗票：選班次、掃描或貼上憑證，結果面板顯示成功與本次已驗票數",
      "caption": "接駁車驗票：選班次、掃描或貼上憑證，結果面板顯示成功與本次已驗票數"
    },
    {
      "name": "roster",
      "alt": "乘客名單：搜尋、篩選未驗票與候補，不含行動電話",
      "caption": "乘客名單：搜尋、篩選未驗票與候補，不含行動電話"
    }
  ]
}
